<template>
    <div>
        <div class="px-4">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import Breadcrumb from './Breadcrumb.vue';
export default {
    components: { Breadcrumb },
    props: ['year']
}
</script>